import * as pdfjsLib from 'pdfjs-dist'

const workerMeta = document.querySelector('meta[name="pdf-worker-url"]')
if (workerMeta?.content) {
  pdfjsLib.GlobalWorkerOptions.workerSrc = workerMeta.content
}

// clientWidth includes the padding, and the reading surface now has some —
// scaling on it would render every page wider than the room it has.
function contentWidth(container) {
  const { paddingLeft, paddingRight } = getComputedStyle(container)

  return container.clientWidth -
    parseFloat(paddingLeft) -
    parseFloat(paddingRight)
}

export async function renderPdf(url, container) {
  const pdf = await pdfjsLib.getDocument(url).promise
  const containerWidth = contentWidth(container)
  const outputScale = window.devicePixelRatio || 1
  const renderedPages = []

  for (let pageNumber = 1; pageNumber <= pdf.numPages; pageNumber++) {
    const page = await pdf.getPage(pageNumber)
    const unscaledViewport = page.getViewport({ scale: 1 })
    const scale = containerWidth / unscaledViewport.width
    const viewport = page.getViewport({ scale })

    const canvas = document.createElement('canvas')
    canvas.width = Math.floor(viewport.width * outputScale)
    canvas.height = Math.floor(viewport.height * outputScale)
    canvas.style.width = '100%'
    canvas.style.height = 'auto'
    canvas.style.display = 'block'

    if (pageNumber < pdf.numPages) {
      canvas.style.borderBottom = '1px solid #e5e7eb'
    }

    container.appendChild(canvas)

    const ctx = canvas.getContext('2d')
    const transform = outputScale !== 1
      ? [outputScale, 0, 0, outputScale, 0, 0]
      : null
    await page.render({
      canvasContext: ctx,
      viewport,
      transform,
    }).promise

    renderedPages.push({
      page: pageNumber,
      canvas,
      scale,
      pdfWidth: unscaledViewport.width,
      pdfHeight: unscaledViewport.height,
    })
  }

  return renderedPages
}

export function watchContainerWidth(container, callback, options = {}) {
  const threshold = options.threshold ?? 32
  const debounce = options.debounce ?? 200
  let lastWidth = container.clientWidth
  let timer = null

  const observer = new ResizeObserver((entries) => {
    const newWidth = entries[0].contentRect.width
    if (Math.abs(newWidth - lastWidth) <= threshold) return
    lastWidth = newWidth
    if (timer) clearTimeout(timer)
    timer = setTimeout(() => callback(newWidth), debounce)
  })
  observer.observe(container)

  return () => {
    observer.disconnect()
    if (timer) clearTimeout(timer)
  }
}
